import { render, staticRenderFns } from "./ProjectABTestDetail.vue?vue&type=template&id=2593c72d&scoped=true&"
import script from "./ProjectABTestDetail.vue?vue&type=script&lang=js&"
export * from "./ProjectABTestDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProjectABTestDetail.vue?vue&type=style&index=0&lang=less&"
import style1 from "./ProjectABTestDetail.vue?vue&type=style&index=1&id=2593c72d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2593c72d",
  null
  
)

export default component.exports